import { Box, Collapse, IconButton } from '@mui/material'
import React, { useState } from 'react'
import CheckboxInput from '../Common/CheckboxInput'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

interface TemplateItem {
    id: string
    name: string
    subEntityTypes?: TemplateItem[]
    [key: string]: any
}

interface TemplateHierarchyProps {
    templates: TemplateItem[]
    selectedTemplates: string[]
    onSelect: (id: string, value: boolean) => void
    disabled?: boolean
}

const TemplateHierarchy: React.FC<TemplateHierarchyProps> = ({
    templates,
    selectedTemplates,
    onSelect,
    disabled,
}) => {
    return (
        <Box>
            {templates.map((item) => (
                <TemplateNode
                    key={item.id}
                    item={item}
                    selectedTemplates={selectedTemplates}
                    onSelect={onSelect}
                    disabled={!!disabled}
                />
            ))}
        </Box>
    )
}

interface TemplateNodeProps {
    item: TemplateItem
    selectedTemplates: string[]
    onSelect: (id: string, value: boolean) => void
    disabled: boolean
}

const TemplateNode: React.FC<TemplateNodeProps> = ({
    item,
    selectedTemplates,
    onSelect,
    disabled,
}) => {
    const [open, setOpen] = useState(false)
    const hasChildren = item?.subEntityTypes?.length
        ? item?.subEntityTypes?.length > 0
        : false

    return (
        <Box>
            <Box
                display="flex"
                alignItems="center"
                sx={{ marginBottom: '10px' }}
            >
                <Box display="flex" alignItems="center">
                    <CheckboxInput
                        id={item.name}
                        label={item.name + (item.required ? '*' : '')}
                        value={selectedTemplates.includes(item.id)}
                        onChange={(id, value) => onSelect(item.id, value)}
                        disabled={disabled}
                        labelStyels={{ color: '#000000de' }}
                        errorMessage={item.errorMessage}
                    />
                </Box>
                <Box
                    display="flex"
                    alignItems="center"
                    marginLeft="-15px"
                    height="20px"
                >
                    {hasChildren && (
                        <IconButton
                            size="small"
                            onClick={() => setOpen((prev) => !prev)}
                            id={`${item.name}-expand-button`}
                        >
                            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    )}
                </Box>
            </Box>
            {hasChildren && (
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box paddingLeft="30px">
                        <TemplateHierarchy
                            templates={item.subEntityTypes!}
                            selectedTemplates={selectedTemplates}
                            onSelect={onSelect}
                            disabled={disabled}
                        />
                    </Box>
                </Collapse>
            )}
        </Box>
    )
}

export default TemplateHierarchy
